import {
  Clock,
  MessageSquare,
  Settings,
  Shield,
  Star,
  Target,
  TrendingUp,
  Trophy,
  Zap,
} from "lucide-react";

export const CATEGORY_ORDER = [
  "Assault Rifle",
  "Carbine",
  "SMG",
  "LMG",
  "DMR",
  "Sniper Rifle",
  "Shotgun",
  "Pistol",
];

export const DATABASE_ITEMS = [
  {
    title: "Classes",
    url: "/classes",
    icon: Shield,
    description: "Specialist classes & roles",
    event: "navbar-database-classes",
  },
  {
    title: "Attachments",
    url: "/attachments",
    icon: Settings,
    description: "All weapon attachments",
    event: "navbar-database-attachments",
  },
];

export const BUILDS_ITEMS = [
  {
    title: "Weapon Builds",
    url: "/weapons/builds",
    icon: Zap,
    description: "Optimized weapon configurations",
    event: "navbar-builds-weapon-builds",
  },
  {
    title: "Loadouts",
    url: "/loadouts",
    icon: Target,
    description: "Complete character loadouts",
    event: "navbar-builds-loadouts",
  },
  {
    title: "Tier Lists",
    url: "/tier-lists",
    icon: Trophy,
    description: "Community weapon rankings",
    event: "navbar-builds-tier-lists",
  },
];

export const COMMUNITY_ITEMS = [
  {
    title: "Discussions",
    url: "/discussions",
    icon: MessageSquare,
    description: "Join the conversation",
    event: "navbar-community-discussions",
  },
];

export const FILTER_ITEMS = [
  {
    title: "Current Meta",
    url: "/meta",
    icon: TrendingUp,
    description: "Top-voted builds from the last two weeks",
    event: "navbar-discover-meta",
  },
  {
    title: "Top Rated Builds",
    url: "/top-rated",
    icon: Star,
    description: "Highest rated weapon builds",
    event: "navbar-discover-top-rated",
  },
  {
    title: "Newest Builds",
    url: "/newest",
    icon: Clock,
    description: "Recently added weapon builds",
    event: "navbar-discover-newest",
  },
];
